import React, { useState } from 'react';
import { USER_REQUEST_URL, deleteFetchRequest } from '../../store/requests';
import { ArrowIcon } from '../../appearence/icons/arrow_icon';
import Modal from '../Modal';
import { useTranslation } from 'react-i18next';
import { MODAL_SUPER_SMALL_SIZE } from '../helper';
import {errorCallback, makeUrl} from "../../util";
import UsersTable from "./UsersTable";
import { Button } from '@chapche/ui';

const DeleteModalContent = ({handleDelete, handleClose}) => {
    const { i18n } = useTranslation();
    return (
        <>
            <h2 className="modal__title block__title-h3">{i18n.t('app.page.user.modal.title')}</h2>
            <p className="block__content modal__text">{i18n.t('app.page.user.modal.content')}</p>
            <div className="modal__button-group">
                <Button variant="outline" onClick={() => handleClose(null)}>
                    {i18n.t('app.page.user.modal.cancel')}
                </Button>
                <Button onClick={handleDelete}>
                    {i18n.t('app.page.user.modal.delete')}
                </Button>
            </div>
        </>
    )
};

const ProfilesTab = ({usersList, setUsersList, setUsersListModalIsOpen}) => {
    const { i18n } = useTranslation();
    const [deleteUser, setDeleteUser] = useState(null);
    const [selectedList, setSelectedList] = useState([]);

    const handleDeleteUser = () => {
        for(let user of selectedList) {
            deleteFetchRequest(makeUrl([USER_REQUEST_URL, user.id, '/']), null, errorCallback);
        }
        const preparedUsersList = usersList.filter(it => selectedList.findIndex(item => item.id === it.id) === -1);
        setUsersList(preparedUsersList);
        setDeleteUser(null);
        setSelectedList([]);
    };

    const handleFindCheckedValue = (userId) => {
        return selectedList.findIndex(it => it.id === userId) > -1;
    };

    const handleChangeSelectedList = (user) => {
        let newData = [];
        if(handleFindCheckedValue(user.id)) {
            newData = selectedList.filter(it => it.id !== user.id);
        } else {
            newData = [...selectedList, user];
        }
        setSelectedList(newData);
    };

    return (
        <>
            {deleteUser ? 
                <Modal content={<DeleteModalContent handleDelete={handleDeleteUser} handleClose={setDeleteUser} />} 
                    handleCloseModal={setDeleteUser} size={MODAL_SUPER_SMALL_SIZE}/>
                :
                null}
            <h1 className="block__title-h3 users__title users__tab-title">
                <ArrowIcon nameOfClass="users__tab-icon" handleClick={setUsersListModalIsOpen} value={false}/>
                <span className="users__tab-text">{i18n.t('app.page.user.residentsData')}</span>
            </h1>
            <article className="users__article users__article_full-width">
                <UsersTable
                    usersList={usersList}
                    setUsersList={setUsersList}
                    isTab={true}
                    handleChange={handleChangeSelectedList}
                    findCheckedValues={handleFindCheckedValue}/>
                <div className="users__tab-buttons">
                    {selectedList.length ? 
                        <Button variant="outline" className="users__tab-button users__tab-button_margin" onClick={() => setSelectedList([])}>
                            {i18n.t('app.page.user.removeSelected')}
                        </Button>
                        :
                        null}
                    <Button
                        className="users__tab-button"
                        disabled={!selectedList.length}
                        onClick={() => setDeleteUser(selectedList)}
                    >
                        {i18n.t('app.page.user.delete')}
                    </Button>
                </div>
                
            </article>
        </>
    );
};

export default ProfilesTab;
